import type { QueryClient } from '@tanstack/react-query';
import type { TFunction } from 'i18next';
import { planKeys } from '@entities/Plan';
import { toast } from '@shared/ui';
import type { BonusGrant } from '../api/sessionApi';

/**
 * Начисление несгораемых жетонов за тренировку (с 2026-10-22): серия дней, возвращение после перерыва,
 * «Задание дня» с главной. Тост на каждое начисление и перечитка баланса — жетоны видны сразу.
 */
export function announceBonus(t: TFunction, qc: QueryClient, grants: BonusGrant[] | undefined): void {
  if (!grants?.length) return;
  for (const grant of grants) {
    toast({
      tone: 'success',
      title: t(`rewards.${grant.reason}.title`, { count: grant.amount, streak: grant.streak ?? 0 }),
      message: t(`rewards.${grant.reason}.text`, { count: grant.amount, streak: grant.streak ?? 0 }),
    });
  }
  void qc.invalidateQueries({ queryKey: planKeys.quota });
  void qc.invalidateQueries({ queryKey: planKeys.billing });
  void qc.invalidateQueries({ queryKey: ['daily-task'] });
}
